import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getFuel = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/fuel-price/`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const createFuel = async (fuelData, date_time) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/fuel-price/`,
      {
        fuelData,
        date_time
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

export { getFuel, createFuel };
